import type { EnergyAnalysisTrendSeries } from "features/energy-analysis-dashboard/model/types";

import { DynamicEchartsChart } from "components/chart/DynamicChartMemoized";
import { memo, useMemo } from "react";
import { cn } from "utils/styling";

import type {
  CrremPathwayOverlayLine,
  CrremPathwayPartitionBy,
  CrremPathwayScatterSeries,
  CrremYearlyPoint,
} from "../model/types";

import { buildPathwayChartOption } from "../lib/buildPathwayChartOption";

type CrremPathwayChartCanvasProps = {
  baseline: CrremYearlyPoint[];
  heightClassName?: string;
  labels: {
    baseline: string;
    pathway: string;
    year: string;
  };
  overlayLines: CrremPathwayOverlayLine[];
  partitionBy: CrremPathwayPartitionBy;
  pathway: CrremYearlyPoint[];
  scatterSeries?: CrremPathwayScatterSeries[];
  stacks: EnergyAnalysisTrendSeries[];
  unit: string;
  xAxisType?: "category" | "value";
  years: number[];
};

export const CrremPathwayChartCanvas = memo(function CrremPathwayChartCanvas({
  baseline,
  heightClassName = "h-[40rem]",
  labels,
  overlayLines,
  partitionBy,
  pathway,
  scatterSeries,
  stacks,
  unit,
  xAxisType,
  years,
}: CrremPathwayChartCanvasProps) {
  const option = useMemo(
    () =>
      buildPathwayChartOption({
        baseline,
        labels,
        overlayLines,
        partitionBy,
        pathway,
        scatterSeries,
        stacks,
        unit,
        xAxisType,
        years,
      }),
    [baseline, labels, overlayLines, partitionBy, pathway, scatterSeries, stacks, unit, xAxisType, years]
  );

  return (
    <div className={cn("relative min-h-0 w-full [&_h3]:hidden", heightClassName)}>
      <DynamicEchartsChart
        className="h-full w-full"
        lazyUpdate
        notMerge={false}
        option={option}
        replaceMerge={["series"]}
        style={{ height: "100%", width: "100%" }}
        secondYAxisRange={undefined}
        title={undefined}
        tooltip={undefined}
        xAxisRange={undefined}
        yAxisRange={undefined}
      />
    </div>
  );
});
